import type { SxProps, Theme } from "@mui/material/styles";

export const formContainerSx: SxProps<Theme> = {
  width: "100%",
};

export const titleSx: SxProps<Theme> = {
  fontSize: { xs: "3.125rem", md: "4.5rem", lg: "6.25rem" },
  fontWeight: 400,
  color: "#FFFFFF",
  textAlign: "center",
};

export const subtitleSx: SxProps<Theme> = {
  fontSize: "1.25rem",
  fontWeight: 300,
  color: "#FFFFFF",
  textAlign: "center",
};

export const emailInputSx: SxProps<Theme> = {
  "& .MuiInputBase-root": {
    color: "#FFFFFF",
    "&::before": {
      borderBottom: "1px solid rgba(255, 255, 255, 0.42)",
    },
    "&:hover:not(.Mui-disabled)::before": {
      borderBottom: "1px solid rgba(255, 255, 255, 0.87)",
    },
    "&::after": {
      borderBottom: "1px solid rgba(255, 255, 255, 0.87)",
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "1.25rem",
    paddingBottom: "0.5rem",
    textAlign: "center",
    marginBottom: ".75rem",
    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.5)",
      opacity: 1,
    },
  },
  margin: "0 auto",
  width: "100%",
  maxWidth: { xs: "100%", sm: "30rem" },
};

export const buttonSx: SxProps<Theme> = {
  height: { xs: "44px", md: "52px", lg: "70px" },
  fontSize: { xs: "30px", md: "40px", lg: "50px" },
  fontWeight: 400,
  color: "#FFFFFF",
  border: "1px solid grey",
  borderRadius: "4rem",
  paddingX: { xs: "2rem", md: "3rem", lg: "4rem" },
  backgroundColor: "transparent",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  width: "fit-content",
  margin: "0 auto",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
};

export const buttonArrowSx: SxProps<Theme> = {
  width: { xs: "24px", md: "32px" },
  height: { xs: "24px", md: "32px" },
};
